<template>
  <!--Render if a list of runners exist and form data exists-->
  <div v-if="Object.keys(detailedRace).length > 0 && formAvailable && !isMobile" class="competitorinfo">
    <div>
      <div v-for="(r) in sortRunners(detailedRace.competitors)" :key="r.id" class="competitorloop">
        <div :id="r.tabNo" style="scroll-margin-top: 110px;">
          <div v-if="!r.scratched">
            <div class="newCompetitorContainer  pa-3">
              <div class="competitorHeader">
                <div class="float-left" style="width: 100%;">
                  <div style="height:40px;">
                    <v-btn
                      outlined
                      class="font-weight-bold mr-1 mt-1 caption"
                      fab
                      x-small
                      color="white"
                      style="float:left; cursor: default"
                    >{{r.tabNo}}</v-btn>
                    <img
                      v-if="detailedRace.meeting.type === 'THOROUGHBRED' || detailedRace.meeting.type === 'HARNESS'"
                      class="competitorSilk"
                      :src="$silksUrl+'/'+gbsID+'_'+detailedRace.number+'_'+r.tabNo+'_64x64.png'"
                      alt="jockey silks"
                      height="40"
                      style="padding-right: 5px; float: left"
                    />
                    <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'GBR' && r.tabNo" style="display:inline-block;float:left;width:28px;margin-top:5px;margin-right:5px;margin-left:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + r.tabNo]" />
                    <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'AUS' || detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'NZL' && r.tabNo" style="display:inline-block;float:left;width:28px;margin-top:5px;margin-right:5px;margin-left:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + r.tabNo]" />
                    <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'USA' || detailedRace.meeting.track.country === 'MEX' && r.tabNo" style="display:inline-block;float:left;width:28px;margin-top:5px;margin-right:5px;margin-left:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + r.tabNo]" />
                    <div>
                      <span>
                        <h3
                          style="height: 40px; line-height: 40px; float: left; margin-right: 5px"
                        >{{r.name}}</h3>
                        <h4
                          style="height: 40px; line-height: 40px; float: left"
                        >({{r.barrier}})</h4>
                        <h5
                          style="height: 40px; line-height: 40px; float: left; margin-left: 5px; font-size: 11px; font-weight: bold"
                        ><span class="red--text">{{checkEmergencyIn(r.emergencyIndicator)}}</span></h5>
                      </span>
                    </div>
                  </div>
                  <div style="width:100%;height:23px;">
                    <p v-if="!greyhoundMeeting(detailedRace)" style="margin-right: 10px; float: left; font-size: 12px; height: 23px" class="pr-2">
                      <b>Age:</b>
                      {{r.age}}YO
                    </p>
                    <p style="margin-right: 10px; float: left; font-size: 12px; height: 23px" class="pr-2">
                      <b>Sex:</b>
                      {{r.sex}}
                    </p>
                    <p style="margin-right: 10px; float: left; font-size: 12px; height: 23px" class="pr-2">
                      <b>Sire:</b>
                      {{r.sire}}
                    </p>
                    <p style="margin-right: 10px; float: left; font-size: 12px; height: 23px" class="pr-2">
                      <b>Dam:</b>
                      {{r.dam}}
                    </p>
                  </div>
                  <div style="clear:both"></div>
                  <div>
                    <div>
                      <div>
                        <div v-if="!greyhoundMeeting(detailedRace)" class="float-left" style="width:180px;">
                          <div
                            v-if="!r.apprenticeIndicator"
                            style="margin-right: 10px;font-size: 12px; width:180px;height:23px; max-width: 180px; overflow: hidden"
                          >
                          <div v-if="detailedRace.meeting.type === 'HARNESS'">
                            <b>D:</b>
                            {{r.jockey}}
                          </div>
                          <div v-else>
                            <b>J:</b>
                            {{r.jockey}} ({{r.weightTotal}}kg)
                          </div>
                          </div>
                          <div
                            v-if="r.apprenticeIndicator"
                            style="margin-right: 10px;font-size: 12px; width:180px;height:23px; max-width: 180px; overflow: hidden"
                          >
                            <b>J:</b>
                            {{r.jockey}} (a{{r.allowanceWeight}}/{{r.weightTotal}}kg)
                          </div>
                        </div>
                        <div class="float-left" style="width:180px;">
                          <div style="font-size: 12px;height:20px;">
                            <b>T:</b>
                            {{r.trainer}}
                            <template v-if="greyhoundMeeting(detailedRace)">
                              <b>Prize: </b>
                              ${{numeral(r.prizeMoney).format('0,00')}}
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="competitorOwners">
                      <v-tooltip bottom color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <p
                            v-bind="attrs"
                            v-on="on"
                            style="font-size: 12px;
                                white-space: nowrap;
                                width: 470px;
                                text-overflow: ellipsis;
                                overflow: hidden;"
                          >
                            <b>Owners:</b>
                            {{r.owners}}
                          </p>
                        </template>
                        <span>{{r.owners}}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <span>
                <div :class="`competitorStatContainer` + '-' + detailedRace.meeting.type" v-if="r.runnerStatistics">
                  <div>
                    <p>
                      <b>Career</b>
                    </p>
                    <p>
                      <b>{{r.runnerStatistics.career.all.numberOfRuns}}:</b>
                      {{r.runnerStatistics.career.all.firsts}}-{{r.runnerStatistics.career.all.seconds}}-{{r.runnerStatistics.career.all.thirds}}
                    </p>
                  </div>
                  <div v-if="!greyhoundMeeting(detailedRace)">
                    <p>
                      <b>Prize</b>
                    </p>
                    <p>
                      <b>${{numeral(r.prizeMoney).format('0,00')}}</b>
                    </p>
                  </div>
                  <div>
                    <p>
                      <b>Win %</b>
                    </p>
                    <p v-if="r.runnerStatistics.career.all.winPercentage">
                      <b>{{r.runnerStatistics.career.all.winPercentage}}%</b>
                    </p>
                    <p v-else>
                      <b>{{calculateWinPercentage(r.runnerStatistics.career.all)}}</b>
                    </p>
                  </div>
                  <div>
                    <p>
                      <b>Place %</b>
                    </p>
                    <p v-if="r.runnerStatistics.career.all.placePercentage">
                      <b>{{r.runnerStatistics.career.all.placePercentage}}%</b>
                    </p>
                    <p v-else>
                      <b>{{calculatePlacePercentage(r.runnerStatistics.career.all)}}</b>
                    </p>
                  </div>
                  <div v-if="detailedRace.meeting.type !== 'GREYHOUND' && detailedRace.meeting.type !== 'HARNESS'">
                    <p>
                      <b>1stUp</b>
                    </p>
                    <p>
                      <b>{{r.runnerStatistics.career.spell.firstUp.numberOfRuns}}:</b>
                      {{r.runnerStatistics.career.spell.firstUp.firsts}}-{{r.runnerStatistics.career.spell.firstUp.seconds}}-{{r.runnerStatistics.career.spell.firstUp.thirds}}
                    </p>
                  </div>
                  <div v-if="detailedRace.meeting.type !== 'GREYHOUND' && detailedRace.meeting.type !== 'HARNESS'">
                    <p>
                      <b>2ndUp</b>
                    </p>
                    <p>
                      <b>{{r.runnerStatistics.career.spell.secondUp.numberOfRuns}}:</b>
                      {{r.runnerStatistics.career.spell.secondUp.firsts}}-{{r.runnerStatistics.career.spell.secondUp.seconds}}-{{r.runnerStatistics.career.spell.secondUp.thirds}}
                    </p>
                  </div>
                  <div v-if="!greyhoundMeeting(detailedRace) && detailedRace.meeting.type !== 'HARNESS'">
                    <p>
                      <b>3rdUp</b>
                    </p>
                    <p>
                      <b>{{r.runnerStatistics.career.spell.thirdUp.numberOfRuns}}:</b>
                      {{r.runnerStatistics.career.spell.thirdUp.firsts}}-{{r.runnerStatistics.career.spell.thirdUp.seconds}}-{{r.runnerStatistics.career.spell.thirdUp.thirds}}
                    </p>
                  </div>
                  <div v-if="!greyhoundMeeting(detailedRace) && detailedRace.meeting.type !== 'HARNESS'">
                    <p>
                      <b>4thUp</b>
                    </p>
                    <p>
                      <b>{{r.runnerStatistics.career.spell.fourthUp.numberOfRuns}}:</b>
                      {{r.runnerStatistics.career.spell.fourthUp.firsts}}-{{r.runnerStatistics.career.spell.fourthUp.seconds}}-{{r.runnerStatistics.career.spell.fourthUp.thirds}}
                    </p>
                  </div>
                  <div
                    v-for="(t, index) in mutateTrack(r.runnerStatistics.career.detail.byTrack, detailedRace.meeting.track.name)"
                    :key="index+1"
                  >
                    <p>
                      <b>Track</b>
                    </p>
                    <p>
                      <b>{{t.numberOfRuns}}:</b>
                      {{t.firsts}}-{{t.seconds}}-{{t.thirds}}
                    </p>
                  </div>
                  <template>
                    <div
                      v-for="(h, index) in mutateDistance(r.runnerStatistics.career.detail.byDistance, detailedRace.distance)"
                      :key="index+50"
                    >
                      <div v-if="detailedRace.distance == h.key">
                        <p>
                          <b>Distance</b>
                        </p>
                        <p>
                          <b>{{h.numberOfRuns}}:</b>
                          {{h.firsts}}-{{h.seconds}}-{{h.thirds}}
                        </p>
                      </div>
                    </div>
                  </template>
                  <template v-if="detailedRace.meeting.type !== 'HARNESS'">
                    <div
                      v-for="(t, index) in mutateTrackDistance(r.runnerStatistics.career.detail.byTrackAndDistance, detailedRace.meeting.track.name, detailedRace.distance)"
                      :key="index+200"
                    >
                      <p>
                        <b>Trk.Dist</b>
                      </p>
                      <p>
                        <b>{{t.numberOfRuns}}:</b>
                        {{t.firsts}}-{{t.seconds}}-{{t.thirds}}
                      </p>
                    </div>
                  </template>
                  <template v-if="!greyhoundMeeting(detailedRace) && detailedRace.meeting.type !== 'HARNESS'">
                    <div
                      v-for="(c, index) in mutateCondition(r.runnerStatistics.career.detail.byCondition)"
                      :key="index+100"
                    >
                      <p :class="['color-' + checkTrackCond(c.key)]">
                        <b>{{checkTrackCond(c.key)}}</b>
                      </p>
                      <p>
                        <b>{{c.numberOfRuns}}:</b>
                        {{c.firsts}}-{{c.seconds}}-{{c.thirds}}
                      </p>
                    </div>
                  </template>
                  <template v-if="!greyhoundMeeting(detailedRace) && detailedRace.meeting.type !== 'HARNESS'">
                    <div
                      v-for="(c, index) in mutateSurface(r.runnerStatistics.career.detail.bySurface)"
                      :key="index+150"
                    >
                      <p :class="['color-' + checkTrackCond(c.key)]">
                        <b>{{checkTrackCond(c.key)}}</b>
                      </p>
                      <p>
                        <b>{{c.numberOfRuns}}:</b>
                        {{c.firsts}}-{{c.seconds}}-{{c.thirds}}
                      </p>
                    </div>
                  </template>
                </div>
              </span>
            </div>
            <div>
              <div v-if="typeof featureToggle[bookie].runnerComments === 'undefined'" class="competitorComment pa-3" style="background:#efefef">
                <!-- Temporary until FC Comments are back for Harness -->
                <template v-if="(detailedRace.meeting.type !== 'HARNESS')">
                  <v-chip label class="primaryTxt" color="primaryCol subtitle-2 mb-2">Runner Comments</v-chip>
                  <div
                    class="text-justify body-2 black--text"
                    style="font-size: 12px"
                  >{{getRunnerComment(r.comments)}}</div>
                </template>
              </div>
              <RunnerDetails :runnerForm="r.formHistory" :runnerTabNo="r.tabNo" :runnerName="r" :race="detailedRace" />
            </div>
          </div>
          <div v-else>
            <div class="newCompetitorContainerScratched pa-3">
              <div class="competitorHeader">
                <v-btn
                  outlined
                  class="font-weight-bold mr-1 mt-1 caption"
                  fab
                  x-small
                  color="white"
                  style="float:left; cursor: default"
                >{{r.tabNo}}</v-btn>
                <img
                  v-if="detailedRace.meeting.type === 'THOROUGHBRED' || detailedRace.meeting.type === 'HARNESS'"
                  class="competitorSilk"
                  :src="$silksUrl+'/'+gbsID+'_'+detailedRace.number+'_'+r.tabNo+'_64x64.png'"
                  alt="jockey silks"
                  height="40"
                  style="padding-right: 5px; float: left"
                />
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'GBR' && r.tabNo" style="display:inline-block;float:left;width:28px;margin-top:5px;margin-right:5px;margin-left:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + r.tabNo]" />
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'AUS' || detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'NZL' && r.tabNo" style="display:inline-block;float:left;width:28px;margin-top:5px;margin-right:5px;margin-left:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + r.tabNo]" />
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'USA' || detailedRace.meeting.track.country === 'MEX' && r.tabNo" style="display:inline-block;float:left;width:28px;margin-top:5px;margin-right:5px;margin-left:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + r.tabNo]" />
                <div>
                  <span>
                    <h3
                      style="line-height: 40px; float: left; margin-right: 5px; text-decoration: line-through;"
                    >{{r.name}}</h3>
                    <h4
                      style="line-height: 40px; float: left; text-decoration: line-through;"
                    >({{r.barrier}})</h4>
                  </span>
                </div>
              </div>
              <div class="competitorStatContainer" style="text-align: right;">
                <h2 style="color: lightgrey;">SCRATCHED</h2>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
  <!--Skeleton loader for when the runner query has not finished but form is available-->
  <div v-else-if="formAvailable" class="no-result">
    <v-skeleton-loader type="table-heading, list-item-two-line, date-picker, table-tfoot"></v-skeleton-loader>
  </div>
  <!--Render if no data is available-->
  <div v-else style="margin-top: 70px;" class="text-center">
    <h1>Sorry, there is currently no form available for this meeting.</h1>
  </div>
</template>

<script>
import numeral from 'numeral'
import RunnerDetails from '@/components/RunnerDetails'
import { featureToggle } from '../common/config'
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  name: 'RunnersList',
  components: { RunnerDetails },
  data () {
    return {
      numeral,
      featureToggle,
      raceTypeImg: {
        HARNESS: '/img/race_types/DO_RaceType_Harness-BLACK.svg',
        GREYHOUND: '/img/race_types/DO_RaceType_Greyhounds-BLACK.svg',
        THOROUGHBRED: '/img/race_types/DO_RaceType_Gallops-BLACK.svg'
      }
    }
  },
  computed: {
    ...mapState(['detailedRace', 'gbsID', 'bookie']),
    ...mapGetters(['isMobile'])
  },
  methods: {
    ...mapActions(['fetchRunnerStarts']),
    greyhoundMeeting (data) {
      return data.meeting.type === 'GREYHOUND'
    },
    sortRunners (data) {
      return data.slice().sort((a, b) => a.tabNo - b.tabNo)
    },
    getRunnerComment (comments) {
      const filteredComments = comments.filter(b => b.source !== 'RAS')
      return filteredComments[0]?.comment || ''
    },
    calculateWinPercentage (stats) {
      if (stats.numberOfRuns !== 0) {
        const percentage = (stats.firsts / stats.numberOfRuns) * 100
        return `${percentage.toFixed(1)}%`
      } else {
        return '0.0%'
      }
    },
    calculatePlacePercentage (stats) {
      if (stats.numberOfRuns !== 0) {
        const percentage = ((stats.seconds + stats.thirds) / stats.numberOfRuns) * 100
        return `${percentage.toFixed(1)}%`
      } else {
        return '0.0%'
      }
    },
    checkEmergencyIn (indicator) {
      if (indicator === true) {
        return 'E'
      } else {
        return ''
      }
    },
    mutateTrackDistance (obj, track, distance) {
      let distanceTrackObj = {
        firsts: 0,
        key: `${track}, ${distance}`,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      obj?.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (b.key == `(${track}, ${distance})`) {
          distanceTrackObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [distanceTrackObj]
    },
    mutateDistance (distance, data) {
      let distanceObj = {
        firsts: 0,
        key: data,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      distance?.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (b.key == data) {
          distanceObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [distanceObj]
    },
    mutateTrack (track, data) {
      let trackObj = {
        firsts: 0,
        key: data,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      track?.forEach(b => {
        if (b.key === data) {
          trackObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [trackObj]
    },
    mutateSurface (surface) {
      let syntheticNumberOfRuns = 0
      let syntheticFirsts = 0
      let syntheticSeconds = 0
      let syntheticThirds = 0
      let newKey = ''
      const surfaceObj = {}
      const syntheticObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Synthetic'
      }
      surfaceObj[syntheticObj.key] = syntheticObj
      surface?.forEach(b => {
        if (b.key.includes('Synthetic')) {
          syntheticNumberOfRuns += b.numberOfRuns
          syntheticFirsts += b.firsts
          syntheticSeconds += b.seconds
          syntheticThirds += b.thirds
        }
        newKey = b.key.split(/(\d+)/)
        if (newKey[0] === 'Synthetic') {
          const blah = {
            numberOfRuns: syntheticNumberOfRuns,
            firsts: syntheticFirsts,
            seconds: syntheticSeconds,
            thirds: syntheticThirds,
            key: newKey[0]
          }
          surfaceObj[blah.key] = blah
        }
      })
      return Object.values(surfaceObj)
    },
    mutateCondition (condition) {
      let firmNumberOfRuns = 0
      let firmFirsts = 0
      let firmSeconds = 0
      let firmThirds = 0
      let goodNumberOfRuns = 0
      let goodFirsts = 0
      let goodSeconds = 0
      let goodThirds = 0
      let heavyNumberOfRuns = 0
      let heavyFirsts = 0
      let heavySeconds = 0
      let heavyThirds = 0
      let softNumberOfRuns = 0
      let softFirsts = 0
      let softSeconds = 0
      let softThirds = 0
      let newKey = ''
      const conditionObj = {}
      const firmObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Firm'
      }
      conditionObj[firmObj.key] = firmObj
      const goodObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Good'
      }
      conditionObj[goodObj.key] = goodObj
      const softObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Soft'
      }
      conditionObj[softObj.key] = softObj
      const heavyObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Heavy'
      }
      conditionObj[heavyObj.key] = heavyObj
      condition?.forEach(b => {
        if (b.key.includes('Firm')) {
          firmNumberOfRuns += b.numberOfRuns
          firmFirsts += b.firsts
          firmSeconds += b.seconds
          firmThirds += b.thirds
        }
        if (b.key.includes('Good')) {
          goodNumberOfRuns += b.numberOfRuns
          goodFirsts += b.firsts
          goodSeconds += b.seconds
          goodThirds += b.thirds
        }
        if (b.key.includes('Soft')) {
          softNumberOfRuns += b.numberOfRuns
          softFirsts += b.firsts
          softSeconds += b.seconds
          softThirds += b.thirds
        }
        if (b.key.includes('Heavy')) {
          heavyNumberOfRuns += b.numberOfRuns
          heavyFirsts += b.firsts
          heavySeconds += b.seconds
          heavyThirds += b.thirds
        }
        newKey = b.key.split(/(\d+)/)
        if (newKey[0] === 'Firm') {
          const blah = {
            numberOfRuns: firmNumberOfRuns,
            firsts: firmFirsts,
            seconds: firmSeconds,
            thirds: firmThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
        if (newKey[0] === 'Good') {
          const blah = {
            numberOfRuns: goodNumberOfRuns,
            firsts: goodFirsts,
            seconds: goodSeconds,
            thirds: goodThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
        if (newKey[0] === 'Soft') {
          const blah = {
            numberOfRuns: softNumberOfRuns,
            firsts: softFirsts,
            seconds: softSeconds,
            thirds: softThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
        if (newKey[0] === 'Heavy') {
          const blah = {
            numberOfRuns: heavyNumberOfRuns,
            firsts: heavyFirsts,
            seconds: heavySeconds,
            thirds: heavyThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
      })
      return Object.values(conditionObj)
    },
    checkTrackCond: function (condition) {
      switch (condition) {
        case 'FIRM1':
          return 'Firm1'
        case 'Firm1':
          return 'Firm1'
        case 'FIRM2':
          return 'Firm2'
        case 'Firm2':
          return 'Firm2'
        case 'GOOD3':
          return 'Good3'
        case 'Good3':
          return 'Good3'
        case 'GOOD4':
          return 'Good4'
        case 'Good4':
          return 'Good4'
        case 'SOFT5':
          return 'Soft5'
        case 'Soft5':
          return 'Soft5'
        case 'SOFT6':
          return 'Soft6'
        case 'Soft6':
          return 'Soft6'
        case 'SOFT7':
          return 'Soft7'
        case 'Soft7':
          return 'Soft7'
        case 'HEAVY8':
          return 'Heavy8'
        case 'Heavy8':
          return 'Heavy8'
        case 'HEAVY9':
          return 'Heavy9'
        case 'Heavy9':
          return 'Heavy9'
        case 'HEAVY10':
          return 'Heavy10'
        case 'Heavy10':
          return 'Heavy10'
        case 'SYNTHETIC' || 'Synthetic':
          return 'Synthetic'
        default:
          return condition
      }
    }
  },
  props: {
    formAvailable: Boolean
  }
}
</script>

<style scoped>
.competitorHeader {
  grid-area: header;
}
.newCompetitorContainer {
  box-shadow: 1px 2px 2px 1px lightgray;
  background-color: rgb(44, 56, 65);
  margin: 0;
  display: grid;
  width:1024px;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  grid-template-areas: "header stats";
}
.newCompetitorContainerScratched {
  box-shadow: 1px 2px 2px 1px lightgrey;
  background-color: rgb(44, 56, 65);
  margin: 0;
  width:1024px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  grid-template-areas: "header stats";
}

.newCompetitorContainerMobile {
  box-shadow: 1px 2px 2px 1px lightgray;
  background-color: rgb(44, 56, 65);
  margin: 0;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  grid-template-areas: "header stats";
}
.newCompetitorContainerScratchedMobile {
  box-shadow: 1px 2px 2px 1px lightgrey;
  background-color: rgb(44, 56, 65);
  margin: 0;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  grid-template-areas: "header stats";
}
h3 {
  font-size: 16px;
}
.color-Firm {
  color: rgb(0, 204, 255);
}
.color-Firm1 {
  color: rgb(0, 204, 255);
}
.color-Firm2 {
  color: rgb(0, 204, 255);
}
.color-Good {
  color: rgb(0, 219, 0);
}
.color-Good3 {
  color: rgb(0, 219, 0);
}
.color-Good4 {
  color: rgb(0, 219, 0);
}
.color-Soft {
  color: rgb(224, 210, 56);
}
.color-Soft5 {
  color: rgb(224, 210, 56);
}
.color-Soft6 {
  color: rgb(224, 210, 56);
}
.color-Soft7 {
  color: rgb(224, 210, 56);
}
.color-Heavy {
  color: orange;
}
.color-Heavy8 {
  color: orange;
}
.color-Heavy9 {
  color: orange;
}
.color-Heavy10 {
  color: orange;
}
.color-Heavy11 {
  color: orange;
}
.color-Synthetic {
  color: #ff58ff;
}
.color-Night {
  color: lightgrey;
}
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
.competitorinfo {
  background-color: white;
  box-shadow: 3px 5px 5px lightgrey;
}
.competitorloop {
  color: white;
  line-height: 30px;
  text-align: justify;
  padding-bottom: 5px;
}
.competitorSilk {
  grid-area: leftsilk;
  align-self: center;
  justify-self: center;
}
.competitorOwners {
  grid-area: right;
}
.competitorStatContainer {
  grid-area: stats;
  line-height: 25px;
  text-align: center;
  grid-gap: 5px;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 11px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
}
.competitorStatContainer-THOROUGHBRED {
  grid-area: stats;
  line-height: 25px;
  text-align: center;
  grid-gap: 5px;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 11px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
}
.competitorStatContainer-GREYHOUND {
  grid-area: stats;
  line-height: 25px;
  text-align: center;
  grid-gap: 5px;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 11px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.competitorStatContainer-HARNESS {
  grid-area: stats;
  line-height: 25px;
  text-align: center;
  grid-gap: 5px;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 11px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
p {
  margin: 0;
}
h2 {
  margin: 0;
}
/* UK Greys */
.greyhoundSpriteUk-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUk-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUk-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUk-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUk-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUk-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUk-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUk-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -196px;
}
/* AUS Greys */
.greyhoundSpriteAUS-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteAUS-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteAUS-3 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteAUS-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteAUS-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteAUS-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteAUS-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteAUS-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteAUS-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteAUS-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -252px;
}
/* US Greys */
.greyhoundSpriteUs-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUs-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUs-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUs-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUs-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUs-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUs-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUs-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteUs-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteUs-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -252px;
}
</style>
